var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    fit: "",
    height: 24,
    width: 24,
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#30CEEF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M24,12.8H8v-1.7c0-0.8,0.7-1.5,1.5-1.5h0.8V9.3c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3v0.3 h6.4V9.3c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3v0.3h0.8c0.8,0,1.5,0.7,1.5,1.5V12.8z M9.5,24C8.7,24,8,23.3,8,22.5v-8.2h16v8.2 c0,0.8-0.6,1.5-1.5,1.5H9.5z M14.6,21.4c0.4,0.4,1,0.4,1.4,0l3.3-3.3c0.4-0.4,0.4-1,0-1.4c0,0,0,0,0,0c-0.4-0.4-1-0.4-1.4,0 l-2.6,2.6l-1.2-1.2c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4L14.6,21.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCalendar);
export default __webpack_public_path__ + "static/media/check-calendar.1fb4ab8a3ca18b27645dec2364fff49d.svg";
export { ForwardRef as ReactComponent };